module.exports = __webpack_public_path__ + "ae0a8ef7974daeb63504325654009a01.pdf";